module.exports = __webpack_public_path__ + "static/red_label_2-7ef9bef8cfd32441810fd0935415e272.png";